import DropzoneAvatar from './DropzoneAvatar';
export default DropzoneAvatar;
